var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSignout = function SvgSignout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.5 2.002a.5.5 0 0 0-.5.5v15.732a.5.5 0 0 0 .299.457l7.437 3.266a.5.5 0 0 0 .701-.458v-2.94H14a1.5 1.5 0 0 0 1.5-1.5v-4.52a.5.5 0 0 0-1 0v4.52a.5.5 0 0 1-.5.5h-2.563V6.86a1 1 0 0 0-.598-.916L4.137 3.002H14a.5.5 0 0 1 .5.5V7.52a.5.5 0 1 0 1 0V3.502a1.5 1.5 0 0 0-1.5-1.5zm14.11 10.31a.5.5 0 0 0 .702.079l2.5-2a.5.5 0 0 0 0-.781l-2.5-2a.5.5 0 0 0-.624.78l1.387 1.11H13.5a.5.5 0 0 0 0 1h5.575l-1.387 1.11a.5.5 0 0 0-.078.703",
    clipRule: "evenodd"
  })));
};
export default SvgSignout;